

class VideoButton {
    constructor() {
        this.playButtons = document.querySelectorAll('.video-button .video-button__play');

        this.initEvent();
    }

    initEvent() {
        for(let playButton of this.playButtons) {
            const video = playButton.parentElement.querySelector('.video-button__media');

            playButton.addEventListener('click', function () {
                if(video.paused) {
                    video.play();
                    playButton.classList.add('hide');
                } else {
                    video.pause();
                    playButton.classList.remove('hide');
                }
            });

            video.addEventListener('click', function () {
                if (!video.paused) {
                    video.pause();
                    playButton.classList.remove('hide');
                }
            });
        }
    }
}

export default VideoButton;
